// extracted by mini-css-extract-plugin
export default {"reValidateCardSection":"x8-z","paymentSection":"y8-z","disabled":"z8-z","sectionButtons":"A8-z","usingAmazonPayMsg":"B8-z"};